import React, { Component } from 'react'
import gql from 'graphql-tag'
import Formsy from 'formsy-react'
import Axios from 'axios'
import config from 'config'
import FileSaver from 'file-saver'
import delay from 'lib/delay'
import analytics from 'lib/analytics'
import Button from 'components/UI/Button/Button'
import IconButton from 'components/UI/Button/IconButton'
import Icon from 'components/UI/Icon/Icon'
import StudentInfoRow from '../StudentInfoRow/StudentInfoRow'
import MobileStudentInfoRow from '../MobileStudentInfoRow/MobileStudentInfoRow'
import SensitiveInfoPopup from 'modules/dashboard/DashboardPopup/SensitiveInfoPopup/SensitiveInfoPopup'
import ParentEmailPopup from '../../../../../DashboardPopup/ParentEmailPopup/ParentEmailPopup'
import GeneralErrorPopup from 'modules/dashboard/DashboardPopup/GeneralErrorPopup/GeneralErrorPopup'
import {
  Wrapper,
  TopButtonRow,
  TitleRow,
  TitleRowElement,
  BottomButtonRow,
  AddButtonContainer,
  AddButtonText,
  UndoSaveButtonContainer,
  MobileTopRow,
  MobileTitleRow,
  MobileTitleRowElement,
  MobileBottomRow
} from './StudentList.styles.js'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import { phoneMaxWidth, Title } from '../../../../DashboardSettings.styles'

export default class StudentList extends Component {
  constructor (props) {
    super(props)

    this.state = {
      initialState: {},
      students: undefined,
      isEditMode: false,
      hasSeenParentEmailPopup: false
    }

    this.isValidUsername = this.isValidUsername.bind(this)
    this.onAddStudent = this.onAddStudent.bind(this)
    this.onRemoveStudent = this.onRemoveStudent.bind(this)
    this.setStudentState = this.setStudentState.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.openSensitiveInfoModal = this.openSensitiveInfoModal.bind(this)
    this.onDownloadStudentList = this.onDownloadStudentList.bind(this)
    this.openParentEmailPopup = this.openParentEmailPopup.bind(this)
    this.renderMobileBottomButtonRow = this.renderMobileBottomButtonRow.bind(
      this
    )
  }

  componentDidMount () {
    if (this.props.students) {
      const students = this.props.students.filter(student => student.username).sort((a, b) => {
        var nameA = a.username.toUpperCase()
        var nameB = b.username.toUpperCase()
        if (nameA < nameB) return -1
        if (nameA > nameB) return 1
        return 0
      })

      this.setState({
        initialState: { students },
        students
      })
    }
  }

  async isValidUsername (username, userId) {
    const isAlphanumerical = /^([a-zA-Z0-9]|_|-|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B){3,}$/.test(
      username
    )

    const originalUsername =
      (
        this.state.initialState.students.find(
          student => student._id === userId
        ) || {}
      ).username ||
      this.state.students.find(student => student._id === userId)
        .originalUsername

    if (!isAlphanumerical) {
      this.setValidUsername(userId, false)
      return false
    }

    if (username === originalUsername) {
      this.setValidUsername(userId, true)
      return true
    }

    const { data } = await this.props.client.query({
      query: gql`
        query freeUsername($username: String!) {
          freeUsername(username: $username)
        }
      `,
      variables: { username },
      fetchPolicy: 'network-only'
    })

    this.setValidUsername(userId, data.freeUsername)
    return data.freeUsername
  }

  setValidUsername (id, isValid) {
    this.setState({
      students: this.state.students.map(student => {
        if (student._id === id) return { ...student, isValidUsername: isValid }
        return student
      })
    })
  }

  allUsernamesValid () {
    return this.state.students.every(
      student => student.isValidUsername !== false
    )
  }

  setStudentState ({ _id, field, value }) {
    this.setState({
      students: this.state.students.map(
        student =>
          student._id === _id ? { ...student, [field]: value } : student
      )
    })
  }

  async onAddStudent () {
    const { data } = await this.props.client.query({
      query: gql`
        query generateUsernames($count: Int) {
          generateUsernames(count: $count)
        }
      `,
      variables: { count: 1 },
      fetchPolicy: 'network-only'
    })

    const newUsername = data && data.generateUsernames[0]

    this.setState({
      students: [
        ...this.state.students,
        {
          _id: Math.floor(Math.random() * 99999999),
          name: '',
          username: newUsername || '',
          originalUsername: newUsername || '',
          parentEmail: '',
          yearGroup: this.props.yearGroup,
          isNew: true
        }
      ],
      isEditMode: true
    })
  }

  onRemoveStudent (studentId) {
    this.setState({
      students: this.state.students.reduce((result, student) => {
        if (student._id !== studentId) {
          result.push(student)
        } else if (!student.isNew) {
          result.push({
            ...student,
            stagedForDeletion: true
          })
        }
        return result
      }, [])
    })
  }

  async onSubmit (auth) {
    const validationResults = this.state.students.map((_, i) => {
      this.refs[`your-class-${i}`].submit()
      return this.refs[`your-class-${i}`].state.isValid
    })

    if (!validationResults.every(result => result)) return

    if (!this.allUsernamesValid()) return

    const students = this.state.students
    const changedSensitiveInfo = this.state.students.some(
      student => student.stagedForDeletion
    )

    if (changedSensitiveInfo) {
      return this.openSensitiveInfoModal()
    }
    try {
      await this.updateStudentDetails()
      await this.addStudents()
      this.setState({ isEditMode: false })
      await delay(1000)
      await this.refetchData()
    } catch (e) {
      this.props.modal.forceOpen(<GeneralErrorPopup isSettings />)
    }
  }

  openSensitiveInfoModal () {
    const modal = this.props.modal

    modal.open(
      <SensitiveInfoPopup
        onConfirm={({ password }) => {
          Promise.all(
            this.state.students
              .filter(student => student.stagedForDeletion)
              .map(async student => {
                await this.props.deleteStudent(student._id, password)
              })
          )
            .then(async () => {
              await this.updateStudentDetails()
              await this.addStudents()
              modal.close()
              this.setState({ isEditMode: false })
              await delay(1000)
              await this.refetchData()
            })
            .catch(e => {
              if (
                e.graphQLErrors &&
                e.graphQLErrors[0].message === 'Access Denied'
              ) {
                return modal.updateProps({
                  passwordError: true
                })
              }
              modal.forceOpen(<GeneralErrorPopup isSettings />)
            })
        }}
        onCancel={() => modal.close()}
      />,
      'sensitiveInfoPopup'
    )
  }

  async updateStudentDetails () {
    try {
      await this.props.updateStudentDetails(
        this.state.students
          .filter(student => !student.stagedForDeletion && !student.isNew)
          .map(student => ({
            _id: student._id,
            name: student.name,
            username: student.username,
            password: student.password,
            parentEmail: student.parentEmail,
            yearGroup: parseInt(student.yearGroup)
          }))
      )
    } catch (e) {
      throw e
    }
  }

  async addStudents () {
    const studentsToAdd = this.state.students
      .filter(student => student.isNew)
      .map(student => ({
        name: student.name,
        username: student.username,
        password: student.password,
        parentEmail: student.parentEmail,
        yearGroup: parseInt(student.yearGroup)
      }))

    await this.props.addStudents(studentsToAdd, this.props.loggedInUser._id)
  }

  async refetchData () {
    const { data } = await this.props.client.query({
      query: this.props.queries[0].query,
      fetchPolicy: 'network-only'
    })

    const students = data.me.group.students.users.filter(
      student => student.username
    )

    this.setState({
      initialState: { students },
      students
    })
  }

  onDownloadStudentList () {
    this.setState({ isDownloadingList: true })

    const isParent = this.props.isParent
    const name = this.props.loggedInUser.name

    const data = {
      template: 'teacher_letter',
      data: {
        students: this.state.students.filter(s => !s.demo),
        ...(isParent ? { parent: { name } } : { teacher: { name } })
      }
    }

    Axios({
      method: 'post',
      url: `https://europe-west1-awesome-caster-213612.cloudfunctions.net/generate-teacher-pdf`,
      data,
      responseType: 'blob'
    }).then(res => {
      analytics.track(`Downloaded student pdf`)
      FileSaver.saveAs(
        new Blob([res.data], { type: 'application/pdf' }),
        `NZK-Student-Letters.pdf`
      )
      this.setState({ isDownloadingList: false })
    })
  }

  openParentEmailPopup () {
    if (this.state.hasSeenParentEmailPopup) return

    this.props.modal.open(
      <ParentEmailPopup
        setSeenStatus={() => this.setState({ hasSeenParentEmailPopup: true })}
      />
    )
  }

  renderTopButtonRow () {
    return (
      <TopButtonRow>
        {/* this.props.loggedInUser &&
          this.props.loggedInUser.isGoogle &&
          !this.props.isGoogleGroup && (
          <SyncWithGoogleButton
            color='white'
            onClick={this.props.syncGoogleClass}
          />
        )}
        {this.props.loggedInUser &&
          this.props.loggedInUser.isGoogle &&
          this.props.isGoogleGroup && (
          <SyncWithGoogleButton
            color='white'
            onClick={this.props.syncGoogleStudents}
          />
          ) */}
        { /* this.props.loggedInUser &&
          !this.props.loggedInUser.isGoogle && (
          <GoogleLoginWrapper>
            <GoogleLogin
              clientId={config.googleClientId}
              buttonText='Login with Google'
              className='google-login-button no-dropshadow'
              responseType='code'
              accessType='offline'
              scope='profile email https://www.googleapis.com/auth/classroom.rosters https://www.googleapis.com/auth/classroom.coursework.me https://www.googleapis.com/auth/classroom.courses openid https://www.googleapis.com/auth/classroom.profile.emails'
              onSuccess={this.props.onGoogleSyncSuccess.bind(this)}
              onFailure={console.error}
            />
          </GoogleLoginWrapper>
          ) */ }
        <IconButton
          bgColor={this.state.isEditMode ? colors.grey : colors.lightBlue}
          color='white'
          disabled={this.state.isEditMode || this.state.isDownloadingList}
          onClick={this.onDownloadStudentList}
          iconName='print'
          size='large'
          width='248px'
        >
          {this.state.isDownloadingList ? 'Loading...' : 'Print all'}
        </IconButton>
        {this.state.isEditMode ? (
          <React.Fragment>
            <IconButton
              bgColor={colors.lightBlue}
              color='white'
              iconName='cross'
              size='large'
              onClick={() =>
                this.setState({
                  ...this.state.initialState,
                  isEditMode: false
                })
              }
            >
              Undo
            </IconButton>
            <IconButton
              data-save
              element='button'
              bgColor={colors.grassGreen}
              color='white'
              iconName='check'
              size='large'
              onClick={this.onSubmit}
            >
              Save
            </IconButton>
          </React.Fragment>
        ) : (
          <IconButton
            bgColor={colors.orange}
            color='white'
            onClick={() =>
              this.setState({
                isEditMode: true
              })
            }
            iconName='pencil'
            size='large'
          >
            Edit
          </IconButton>
        )}
      </TopButtonRow>
    )
  }

  renderMobileTopButtonRow () {
    return (
      <MobileTopRow>
        <Title>{this.props.isParent ? 'Children' : 'Students'}</Title>
        {this.state.isEditMode ? (
          <IconButton
            element='button'
            bgColor={colors.grassGreen}
            color='white'
            iconName='check'
            size='regular'
            onClick={this.onSubmit}
          >
            Save
          </IconButton>
        ) : (
          <IconButton
            bgColor={colors.orange}
            color='white'
            onClick={() =>
              this.setState({
                isEditMode: true
              })
            }
            iconName='pencil'
            size='regular'
          >
            Edit
          </IconButton>
        )}
      </MobileTopRow>
    )
  }

  renderTitleRow () {
    const isParent = this.props.isParent

    const columns = [
      {
        id: 'name',
        title: isParent ? "Child's name" : 'Student Name',
        size: 'regular'
      },
      {
        id: 'username',
        title: 'Username',
        size: 'regular'
      },
      {
        id: 'password',
        title: 'Password',
        size: 'regular'
      },
      {
        id: 'parentEmail',
        title: 'Parent Email',
        size: 'large'
      },
      {
        id: 'yearGroup',
        title: 'Age',
        size: 'regular'
      }
    ]

    return (
      <TitleRow>
        {columns
          .filter(
            isParent ? column => column.id !== 'parentEmail' : column => column
          )
          .map(column => {
            return (
              <TitleRowElement key={column.id} size={column.size}>
                {column.title}
              </TitleRowElement>
            )
          })}
      </TitleRow>
    )
  }

  renderMobileTitleRow () {
    return (
      <MobileTitleRow>
        <MobileTitleRowElement left>Username</MobileTitleRowElement>
        <MobileTitleRowElement>Password</MobileTitleRowElement>
      </MobileTitleRow>
    )
  }

  renderStudents () {
    const { screenWidth } = this.props

    return (this.state.students || []).map((student, i) => (
      <Formsy ref={`your-class-${i}`} key={`your-class-${i}`}>
        {screenWidth > phoneMaxWidth ? (
          <StudentInfoRow
            key={student._id}
            info={student}
            isGoogleGroup={this.props.isGoogleGroup}
            screenWidth={screenWidth}
            isEditMode={this.state.isEditMode}
            isValidUsername={this.isValidUsername}
            onRemoveStudent={this.onRemoveStudent}
            setStudentState={this.setStudentState}
            isParent={this.props.isParent}
            onDownloadStudentInfo={this.onDownloadStudentInfo}
            openParentEmailPopup={this.openParentEmailPopup}
            syncGoogleStudents={this.props.syncGoogleStudents}
          />
        ) : (
          <MobileStudentInfoRow
            key={student._id}
            info={student}
            isEditMode={this.state.isEditMode}
            isValidUsername={this.isValidUsername}
            setStudentState={this.setStudentState}
          />
        )}
      </Formsy>
    ))
  }

  renderBottomButtonRow () {
    const { students } = this.state

    return (
      <BottomButtonRow>
        <AddButtonContainer>
          <Button
            element='button'
            bgColor={colors.orange}
            color='white'
            size='regular'
            round
            onClick={this.onAddStudent}
          >
            <Icon name='plus' color='white' size='regular' />
          </Button>
          <AddButtonText onClick={this.onAddStudent}>
            {this.props.isParent ? 'Add Child' : 'Add Student'}
          </AddButtonText>
        </AddButtonContainer>
        {students &&
          students.length > 6 && (
          <UndoSaveButtonContainer>
            {this.state.isEditMode ? (
              <React.Fragment>
                <IconButton
                  bgColor={colors.lightBlue}
                  color='white'
                  iconName='cross'
                  size='regular'
                  onClick={() =>
                    this.setState({
                      ...this.state.initialState,
                      isEditMode: false
                    })
                  }
                >
                    Undo
                </IconButton>
                <IconButton
                  element='button'
                  bgColor={colors.grassGreen}
                  color='white'
                  iconName='check'
                  size='regular'
                  onClick={this.onSubmit}
                >
                    Save
                </IconButton>
              </React.Fragment>
            ) : (
              <IconButton
                bgColor={colors.orange}
                color='white'
                onClick={() =>
                  this.setState({
                    isEditMode: true
                  })
                }
                iconName='pencil'
                size='regular'
              >
                  Edit
              </IconButton>
            )}
          </UndoSaveButtonContainer>
        )}
      </BottomButtonRow>
    )
  }

  renderMobileBottomButtonRow () {
    return (
      <MobileBottomRow>
        {this.state.isEditMode ? (
          <IconButton
            element='button'
            bgColor={colors.grassGreen}
            color='white'
            iconName='check'
            size='regular'
            onClick={this.onSubmit}
          >
            Save
          </IconButton>
        ) : (
          <IconButton
            bgColor={colors.orange}
            color='white'
            onClick={() =>
              this.setState({
                isEditMode: true
              })
            }
            iconName='pencil'
            size='regular'
          >
            Edit
          </IconButton>
        )}
      </MobileBottomRow>
    )
  }

  render () {
    if (this.props.screenWidth > phoneMaxWidth) {
      return (
        <Wrapper>
          {this.renderTopButtonRow()}
          {this.renderTitleRow()}
          {this.renderStudents()}
          {this.renderBottomButtonRow()}
        </Wrapper>
      )
    }
    return (
      <Wrapper>
        {this.renderMobileTopButtonRow()}
        {this.renderMobileTitleRow()}
        {this.renderStudents()}
        {this.renderMobileBottomButtonRow()}
      </Wrapper>
    )
  }
}
